module.exports = __webpack_public_path__ + "images/history-cat-5-44893ce50c3137e2b241628975ea484e.png";


/*****************
 ** WEBPACK FOOTER
 ** ./web/images/history-cat-5.png
 ** module id = 392
 ** module chunks = 0
 **/